import { watch } from 'vue';
import { useStore } from 'vuex';
import { kanbanEnabled } from 'dashboard/permissionSets/kanbanReads';

export const useKanbanPipelines = () => {
  const store = useStore();
  watch(
    [
      () => store.getters.getCurrentAccountId,
      () => kanbanEnabled(store.getters),
    ],
    ([accountId, enabled], previous = []) => {
      store.commit('pipelines/CLEAR_PIPELINES');
      store.commit('kanban/CLEAR_CONVERSATION_ACCESS');
      if (accountId !== previous[0]) {
        store.commit('kanban/SET_BOARD_KEY', null);
        store.commit('kanban/CLEAR_FILTERS');
      }
      if (enabled) store.dispatch('pipelines/get');
    },
    { immediate: true, flush: 'sync' }
  );
};
